// src/components/Modal.js
import React from "react";
import "../App.css";

export default function Modal({ children, onClose }) {
  return (
    <div 
      className="modal-backdrop" 
      onClick={onClose} 
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        animation: "fadeIn 0.3s ease-in-out"
      }}
    >
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()} 
        style={{
          background: "var(--card-bg)",
          border: "1px solid var(--card-border)",
          borderRadius: "14px",
          padding: "20px",
          maxWidth: "80%",
          maxHeight: "80vh",
          overflow: "auto",
          animation: "slideUp 0.3s ease-in-out"
        }}
      >
        <button 
          onClick={onClose} 
          style={{ float: "right", background: "none", border: "none", cursor: "pointer" }}
        >
          Close
        </button>
        {children}
      </div>
    </div>
  );
}
